/* jshint loopfunc: true, strict: false */

console.log('%c😁 ', 'font-size: 48px;')
console.log('%cCurious? ', 'font-size: 24px; font-weight: bold; color: "purple";')
console.log('%cNeed a frontend developer?', 'font-size: 16px; font-weight: bold;')
console.log('%cYou‘re in the right place!', 'font-size: 16px; font-weight: bold;');

// ─── Lang query param ────────────────────────────────────────────────────────

(() => {
  const params = new URLSearchParams(location.search)
  const lang = params.get('lang')

  if (lang) {
    localStorage.setItem('lang', lang)
    document.documentElement.lang = lang
    document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + lang
  }
})()

function $qa(selector, parent = document) {
  return Array.from(parent.querySelectorAll(selector))
}

function $q(selector, parent = document) {
  return parent.querySelector(selector)
}

function addClass(element, className) {
  if (element) {
    element.classList.add(className)
  }
}

function removeClass(element, className) {
  if (element) {
    element.classList.remove(className)
  }
}

function containsClass(element, className) {
  if (element) {
    return element.classList.contains(className)
  }
  return false
}

// ─────────────────────────────────────────────────────────────────────────────

const isMobile = () => /(Android|webOS|Phone|iPad|iPod|BlackBerry|Windows Phone)/i.test(navigator.userAgent)

const debounce = (callback, delay) => {
  let last
  let timer

  return function(...args) {
    const context = this
    const now = Date.now()

    if (last && now < last + delay) {
      clearTimeout(timer)

      timer = setTimeout(() => {
        last = now
        callback.apply(context, args)
      }, delay)
    } else {
      last = now
      callback.apply(context, args)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  'use strict'

  const slideContainer = $q('.slide-container')
  const pageContainer = $q('.work-container')
  const pageNavigation = $q('.work-pagination')
  const totalWorks = $qa('.work').length
  const animationEnd = 'animationend'
  const angle = { contributions: 0 }
  const face = { contributions: 0 }

  let totalPages = totalWorks
  let page = 1

  // ─── Cube 3D ────────────────────────────────────────────────────────────

  const rotateCube = (type) => {
    angle[type] += 90
    face[type] += 1

    if (face[type] >= 4) {
      face[type] = 0
    }

    const cubeFaces = $qa('.' + type + ' div')

    cubeFaces.forEach((faceElement) => {
      removeClass(faceElement, 'active')
    })

    if (cubeFaces[face[type]]) {
      addClass(cubeFaces[face[type]], 'active')
    }

    const cube = $q('.' + type)

    if (cube) {
      cube.style.transform = 'rotateX(' + angle[type] + 'deg)'
    }

    setTimeout(() => {
      rotateCube(type)
    }, Math.random() * 1000 + 1000)
  }

  rotateCube('contributions')

  // ─── Scroll vers un slide (1-based) ────────────────────────────────────

  const scrollToSlide = (idx) => {
    if (!slideContainer) {
      return
    }

    slideContainer.scrollTo({
      top: (idx - 1) * window.innerHeight,
      behavior: 'smooth'
    })
  }

  // ─── Détection du slide visible ─────────────────────────────────────────

  let swipeTimer
  let swipeTimer2

  const slideObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (containsClass(entry.target, 'works')) {
        if (entry.isIntersecting) {
          addClass(document.documentElement, 'works-visible')
        } else {
          removeClass(document.documentElement, 'works-visible')
        }
      }

      if (entry.isIntersecting) {
        if (containsClass(entry.target, 'footer')) {
          addClass(entry.target, 'animated')
        }

        if (containsClass(entry.target, 'header')) {
          swipeTimer = setTimeout(() => {
            $qa('.touch .slide-swipe').forEach((element) => {
              addClass(element, 'vertical')
            })

            $qa('.slide-swipe .icon').forEach((icon) => {
              icon.addEventListener(animationEnd, () => {
                $qa('.slide-swipe').forEach((element) => {
                  removeClass(element, 'vertical')
                })
              }, { once: true })
            })
          }, 3000)
        }

        if (containsClass(entry.target, 'works')) {
          swipeTimer2 = setTimeout(() => {
            $qa('.touch .slide-swipe').forEach((element) => {
              addClass(element, 'horizontal')
            })

            $qa('.slide-swipe .icon').forEach((icon) => {
              icon.addEventListener(animationEnd, () => {
                $qa('.slide-swipe').forEach((element) => {
                  removeClass(element, 'horizontal')
                })
              }, { once: true })
            })
          }, 600)
        }

      } else {
        if (containsClass(entry.target, 'header')) {
          clearTimeout(swipeTimer)
          $qa('.slide-swipe').forEach((element) => {
            removeClass(element, 'vertical')
          })
        }

        if (containsClass(entry.target, 'works')) {
          clearTimeout(swipeTimer2)
          $qa('.slide-swipe').forEach((element) => {
            removeClass(element, 'horizontal')
          })
        }
      }
    })
  }, {
    root: slideContainer,
    threshold: 0.6
  })

  $qa('.slide').forEach((slide) => {
    slideObserver.observe(slide)
  })

  // ─── Navigation Works (horizontal) ─────────────────────────────────────

  const gotoPage = (idx) => {
    page = idx

    const firstWork = $q('.work')

    if (!firstWork || !pageContainer) {
      return
    }

    const width = firstWork.offsetWidth

    pageContainer.scrollTo({
      left: (page - 1) * width,
      behavior: 'smooth'
    })

    const works = $qa('.work', pageContainer)

    works.forEach((work) => {
      removeClass(work, 'active')
    })

    if (works[page - 1]) {
      addClass(works[page - 1], 'active')
    }

    updatePageNavigation()
  }

  const nextPage = () => {
    if (page >= totalPages) {
      return
    }

    page += 1
    gotoPage(page)
  }

  const previousPage = () => {
    if (page <= 1) {
      return
    }

    page -= 1
    gotoPage(page)
  }

  // Touches ← → pour la nav works
  const changePage = (e) => {
    if (e.keyCode === 37) {
      e.preventDefault()
      previousPage()
    }

    if (e.keyCode === 39) {
      e.preventDefault()
      nextPage()
    }
  }

  // Sync pagination quand l'utilisateur swipe nativement dans .work-container
  if (pageContainer) {
    pageContainer.addEventListener('scrollend', () => {
      const firstWork = $q('.work', pageContainer)

      if (!firstWork) {
        return
      }

      const workWidth = firstWork.offsetWidth
      const newPage = Math.round(pageContainer.scrollLeft / workWidth) + 1
      const works = $qa('.work', pageContainer)

      page = Math.max(1, Math.min(newPage, totalPages))

      works.forEach((work) => {
        removeClass(work, 'active')
      })

      if (works[page - 1]) {
        addClass(works[page - 1], 'active')
      }

      updatePageNavigation()
    })
  }

  const updatePageNavigation = () => {
    if (!pageNavigation) {
      return
    }

    const paginationLinks = $qa('a', pageNavigation)
    const previousButton = $q('.work-previous')
    const nextButton = $q('.work-next')

    paginationLinks.forEach((link) => {
      removeClass(link, 'active')
    })

    if (paginationLinks[page - 1]) {
      addClass(paginationLinks[page - 1], 'active')
    }

    if (previousButton) {
      removeClass(previousButton, 'disabled')
      if (page === 1) {
        addClass(previousButton, 'disabled')
      }
    }

    if (nextButton) {
      removeClass(nextButton, 'disabled')

      if (page === totalPages) {
        addClass(nextButton, 'disabled')
      }
    }
  }

  const orientation = () => {
    const orientationAngle = screen.orientation ? screen.orientation.angle : 0
    const swipeHints = $qa('.touch .slide-swipe')

    if (isMobile() && orientationAngle % 180 !== 0) {
      swipeHints.forEach((element) => {
        addClass(element, 'orientation')
      })
    } else {
      swipeHints.forEach((element) => {
        removeClass(element, 'orientation')
      })
    }
  }

  const initWorks = () => {
    const workElement = $q('.work')

    if (!workElement || !pageNavigation) {
      totalPages = 0
      return
    }

    totalPages = Math.ceil(totalWorks / (window.innerWidth / workElement.offsetWidth))
    pageNavigation.innerHTML = ''

    if (totalPages <= 1) {
      return
    }

    for (let x = 0; x < totalPages; x += 1) {
      const link = document.createElement('a')

      link.href = '#'
      link.addEventListener('click', (e) => {

        const links = $qa('a', pageNavigation)

        e.preventDefault()
        gotoPage(Array.from(links).indexOf(e.currentTarget) + 1)
      })
      pageNavigation.appendChild(link)
    }

    if (page > totalPages) {
      page = totalPages
      gotoPage(page)
    }

    updatePageNavigation()
  }

  // ─── Init ────────────────────────────────────────────────────────────────

  initWorks()
  gotoPage(page)

  if ('ontouchstart' in window || 'onmsgesturechange' in window) {
    document.documentElement.classList.add('touch')
  } else {
    document.documentElement.classList.add('no-touch')
  }

  const wrapTextNodes = (root) => {
    Array.from(root.childNodes).forEach((node) => {
      if (node.nodeType === 3) {

        const wrapper = document.createElement('span')

        node.parentNode.insertBefore(wrapper, node)
        wrapper.appendChild(node)
      }
    })
  }

  $qa('.header-bio p').forEach((paragraph) => {
    wrapTextNodes(paragraph)
  })

  const footerParagraph = $q('.footer p')

  if (footerParagraph) {
    wrapTextNodes(footerParagraph)
  }

  $qa('.lang-btn').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()

      const lang = e.currentTarget.getAttribute('data-lang')

      document.documentElement.lang = lang
      document.documentElement.className = document.documentElement.className.replace(/\blang-\w+/g, '') + ' lang-' + lang
      localStorage.setItem('lang', lang)

      const url = new URL(location.href)

      url.searchParams.set('lang', lang)
      history.replaceState(null, '', url)
      restartBubble(lang)
    })
  })

  $qa('.social-email a').forEach((link) => {
    link.setAttribute('href', 'mailto:' + link.getAttribute('href').replace('#', '@').replace('|', '.'))
  })

  $qa('.header-scroll').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      scrollToSlide(2)
    })
  })

  $qa('.work-previous').forEach((button) => {
    button.addEventListener('click', (e) => {
      previousPage()
      e.preventDefault()
    })
  })

  $qa('.work-next').forEach((button) => {
    button.addEventListener('click', (e) => {
      nextPage()
      e.preventDefault()
    })
  })

  setTimeout(() => {
    $qa('.header').forEach((header) => {
      header.classList.add('animated')
    })
  }, 500)

  window.addEventListener('keydown', debounce(changePage, 50))
  window.addEventListener('resize', debounce(initWorks, 250))
  window.addEventListener('orientationchange', orientation)
  window.dispatchEvent(new Event('orientationchange'))
})

// ─── Typing FX ───────────────────────────────────────────────────────────────

const container = document.querySelector('.bubble-text')
const sentences = []
const allSentences = []

let typingGen = 0

$qa('.bubble-text p').forEach((item) => {
  allSentences.push({
    text: item.innerHTML,
    wait: item.dataset.wait,
    back: item.dataset.back,
    lang: item.getAttribute('lang')
  })
})

const collectSentences = (lang) => {
  sentences.length = 0
  allSentences.forEach((sentence) => {
    if (!sentence.lang || sentence.lang === lang) {
      sentences.push(sentence)
    }
  })
}

const restartBubble = (lang) => {
  const gen = typingGen
  
  typingGen += 1

  collectSentences(lang)

  if (!container) {
    return
  }

  container.innerHTML = ''
  
  $qa('.bubble').forEach((bubble) => {
    bubble.classList.add('shown')
  })

  typing(0, gen)
}

collectSentences(document.documentElement.lang)
if (container) {
  container.innerHTML = ''
}

setTimeout(() => {
  typing(0, typingGen)
}, 2000)

const typing = (i, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  if (!sentences[i]) {
    $qa('.bubble').forEach((bubble) => {
      bubble.classList.remove('shown')
    })
    return
  }

  const sentence = sentences[i]
  const text = sentence.text + '_'

  forward(text, 0, () => {
    typing(i + 1, gen)
  }, sentence.wait, sentence.back, gen)
}

const forward = (text, x, callback, wait, back, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  let blinking = ''
  const nextX = x + 1

  if (nextX === text.length) {
    blinking = 'bubble-blinking'
  }

  const part = text.substring(0, nextX)
  const parts = '> ' + part.substring(0, nextX - 1) + '<span class="bubble-cursor ' + blinking + '">' + part.substring(nextX - 1, nextX) + '</span>'

  container.innerHTML = parts

  if (nextX < text.length) {
    setTimeout(() => {
      forward(text, nextX, callback, wait, back, gen)
    }, Math.random() * 70 + 10)
  } else {
    setTimeout(() => {
      if (back) {
        backward(text, nextX, callback, gen)
      } else {
        callback()
      }
    }, wait)
  }
}

const backward = (text, x, callback, gen) => {
  if (gen !== typingGen || !container) {
    return
  }

  const nextX = x - 1

  container.innerHTML = '> ' + text.substring(0, nextX) + '<span class="bubble-cursor">_</span>'

  if (nextX !== 0) {
    setTimeout(() => {
      backward(text, nextX, callback, gen)
    }, Math.random() * 40)
  } else {
    callback()
  }
}
